var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "606D7FC0-42E6-4599-B1E1-DAF331CB11BE") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "NewWebsite",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HomePage_v1",
    transform: "translate(-1481.000000, -57.000000)",
    fill: "#00D4A1",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10-Copy-2",
    transform: "translate(1449.000000, 32.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "key",
    transform: "translate(32.000000, 25.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,8.25004688 C24,12.8063906 20.3063437,16.5 15.75,16.5 C15.2240625,16.5 14.7098438,16.4502187 14.2112344,16.3561406 L13.0856719,17.6224219 C12.872183,17.8625987 12.5661729,18.0000116 12.2448281,18 L10.5,18 L10.5,19.875 C10.5,20.4963281 9.99632812,21 9.375,21 L7.5,21 L7.5,22.875 C7.5,23.4963281 6.99632812,24 6.375,24 L1.125,24 C0.503671875,24 0,23.4963281 0,22.875 L0,19.2159844 C0,18.917625 0.118546875,18.6314531 0.329484375,18.4204688 L7.91395312,10.836 C7.6456875,10.0225313 7.5,9.15332812 7.5,8.25 C7.5,3.69365625 11.1936094,0 15.7499531,0 C20.31975,0 24,3.68020312 24,8.25004688 Z M15.75,6 C15.75,7.24265625 16.7573438,8.25 18,8.25 C19.2426562,8.25 20.25,7.24265625 20.25,6 C20.25,4.75734375 19.2426562,3.75 18,3.75 C16.7573438,3.75 15.75,4.75734375 15.75,6 Z",
    id: "Shape"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.2c5d4954edd26c43f2240f8a64525a89.svg";
export { ForwardRef as ReactComponent };